import axiosInstance from './axios';

export const api = {
  async setupInterview(formData) {
    try {
      const response = await axiosInstance.post('interview/setup_interview/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async checkAuth() {
    try {
      const token = localStorage.getItem('affiliateToken');
      if (!token) {
        return { authenticated: false, data: null };
      }

      axiosInstance.defaults.headers.common['Authorization'] = `Token ${token}`;
      const response = await axiosInstance.get('affiliate/affiliates/me/');
      return { authenticated: true, data: response.data };
    } catch (error) {
      localStorage.removeItem('affiliateToken');
      return { authenticated: false, data: null };
    }
  },

  async login(email, password) {
    try {
      const response = await axiosInstance.post('affiliate/login/', {
        email,
        password,
      });

      const data = response.data;

      if (data.success) {
        axiosInstance.defaults.headers.common['Authorization'] = `Token ${data.token}`;
      }

      return data;
    } catch (error) {
      throw error;
    }
  },

  async connectStripe() {
    try {
      const response = await axiosInstance.post(`affiliate/connect_stripe/`);

      return { success: true, url: response.data.url };
    } catch (error) {
      return { success: false, error };
    }
  },

  async processPayment(paymentDetails) {
    try {
      const response = await axiosInstance.post('interview/process_payment/', paymentDetails);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async trackAffiliateClick(slug) {
    try {
      const res = await axiosInstance.post('affiliate/track_click/', { slug });
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, error };
    }
  },

  async transcribeSpeech(audioBlob) {
    try {
      const formData = new FormData();
      formData.append('audio', audioBlob);
      const response = await axiosInstance.post('interview/transcribe/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async generateResponse(question, context) {
    try {
      const response = await axiosInstance.post('interview/generate_response/', {
        transcription: question,
        context,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async validateSession(session_id) {
    try {
      const response = await axiosInstance.get('interview/session/', {
        params: { session_id },
      });
      return { valid: true, data: response.data };
    } catch (error) {
      return {
        valid: false,
        error: error.response?.data || 'Validation failed',
      };
    }
  },

  async endSession(session_id) {
    try {
      const response = await axiosInstance.post('interview/end_session/', {
        session_id,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async processNLP(transcription, role) {
    try {
      const response = await axiosInstance.post('interview/process_nlp/', {
        transcription,
        role,
      });
      return response.data; // Expected response: { question: "...", context: "..." }
    } catch (error) {
      return null; // Ensure fallback in case of failure
    }
  },

  async extendTime(session_id, minutes) {
    try {
      const response = await axiosInstance.post('interview/extend_time/', {
        session_id,
        minutes,
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || 'Failed to extend time',
      };
    }
  },

  async validateFeedbackSession(session_id) {
    try {
      const response = await axiosInstance.get('interview/get_feedback_prefill/', {
        params: { session_id },
      });
      return { valid: true, data: response.data };
    } catch (error) {
      return {
        valid: false,
        error: error.response?.data || 'Feedback session validation failed',
      };
    }
  },

  async submitFeedback(data) {
    try {
      const response = await axiosInstance.post('interview/submit_feedback/', data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || 'Feedback submission failed',
      };
    }
  },
};
